import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { MenuItem as BaseMenuItem, MenuList as BaseMenuList, Popover as BasePopover } from '@material-ui/core'

export const Root = styled(({ maxHeight, maxWidth, ...props }) => <BasePopover {...props} />)`
  &.MuiPopover-root .MuiPopover-paper {
    background-color: ${props => props.theme.palette.brand.white};
    border: 0;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 ${props => props.theme.palette.gray[0.5]};
    box-sizing: border-box;
    font-family: ${props => props.theme.typography.fontFamily};
    margin: 9px 0;
    padding: 4px 0;

    ${props =>
      props.maxHeight &&
      css`
        max-height: ${props.maxHeight};
      `}

    ${props =>
      props.maxWidth &&
      css`
        max-width: ${props.maxWidth};
        min-width: initial !important;
        width: 100%;
      `}

    ${props => props.theme.breakpoints.down('sm')} {
      max-width: calc(100% - 32px);
    }
  }
`

export const Content = styled(BaseMenuList)`
  &.MuiList-root {
    box-sizing: border-box;
    padding: 0;
  }
`

export const MenuItem = styled(forwardRef(({ enableClose, ...props }, ref) => <BaseMenuItem {...props} ref={ref} />))`
  &.MuiListItem-root {
    background-color: ${props => props.theme.palette.brand.white};
    color: ${props => props.theme.palette.gray[20]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    min-height: 30px;
    padding: 6px 16px;
    transition: none;
    width: 100%;
  }

  &.MuiListItem-root.Mui-selected,
  &.MuiListItem-root.Mui-selected:hover {
    background-color: ${props => props.theme.palette.gray[85]};
  }

  &.MuiListItem-root:focus-visible,
  &.MuiListItem-root:hover,
  &.MuiListItem-root.Mui-focusVisible { {
    background-color: ${props => props.theme.palette.gray[95]};
  }

  &.MuiListItem-root > .MuiTouchRipple-root {
    display: none;
  }
`
